<template>
<div>
    <slot/>
</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'fd-row',
  props: {
  },
  setup () {
    return {
    }
  }
})
</script>

<style lang="scss" scoped>

</style>
